import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import SpriteFile from '@bonniernews/dn-design-system-web/foundations/icons/sprite.svg'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import type { DsIcon } from '@bonniernews/dn-design-system-web/types-lib/ds-icon.d.ts'

export interface IconProps extends SharedProps {
  iconName: DsIcon
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/icon](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/icon-sprite)
 * - Storybook: [icon](https://designsystem.dn.se/?path=/docs/foundations-icons--docs)
 *
 * The IconUse component is used to render a specific icon from the sprite, but mostly we will use the IconWithWrapper component.
 * The IconSprite component is only used to export the sprite file.
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/icon/icon.scss'`
 */
export const IconUse = ({ iconName, classNames, attributes }: IconProps) => {
  const componentClassName = 'ds-icon'

  const classes = formatClassString([
    componentClassName,
    `${componentClassName}--sprite`,
    `${componentClassName}--${iconName}`,
    classNames,
  ])

  return (
    <i className={classes} {...attributes}>
      <svg>
        <use xlinkHref={`#ds-${iconName}`}></use>
      </svg>
    </i>
  )
}

// @ts-ignore
export const IconSprite = () => <SpriteFile />
